export enum SidebarTitle {
  AURORAS = 'auroras',
  FRONTPAGE = 'frontpage',
  PROJECTS = 'projects',
  POWERSUPPLIES = 'powersupplies',
  DEVICES = 'devices',
  COMPANIES = 'companies',
  MANUFACTURING = 'manufacturing',
  USERS = 'users',
  ANNOUNCEMENT_MANAGEMENT = 'announcement_management',
  INSTALL_NEW_DEVICE = 'install_new_device',
  REPLACE_DEVICE = 'replace_device',
  ADD_NEW_RUUVI_TAG = 'add_new_ruuvi_tag',
  CONDITION_MONITORING = 'condition_monitoring',
  HEATERS = 'heaters',
  GENERATORS = 'generators',
  ANALYTICS = 'analytics'
}
